import React, { useEffect } from "react";
import styled from "styled-components";
import TeachersTabs from "../../../components/AdminCentral/Teachers/TeachersTabs";
import TeachersContent from "../../../components/AdminCentral/Teachers/TeachersContent";
import SchoolDistrictContent from "../../../components/AdminCentral/Teachers/SchoolDistrictContent";
import TeacherSettingsContent from "../../../components/AdminCentral/Teachers/TeachersSettingsContent";
import usePersistentTabState from "../../../hooks/usePersistentTabState";


const breakpoints = {
  tablet: 768,
  phone:  480,
};



const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
  background-color: transparent;
`;

const Container = styled.div`
  width: 1100px;
  align-items: center;
  padding: 20px;
  // margin: 20px;
  font-family: Arial, sans-serif;
  border-radius: 5px;
  background-color: ${(props) => props.colors.cardBackground}; 
  @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
    padding: 16px;
  }
  @media (max-width: ${breakpoints.phone}px) {
    width: 400px;
    padding: 0px;
  }
`;

const Title = styled.text`
 font-size: 36px;
  color: ${({ colors }) => colors.titleText};
  font-weight: 600;
  margin-bottom: 20px; 

  span {
    display: block;
    color: black;
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
    @media (max-width: ${breakpoints.phone}px) {
    font-size: 1.5rem;
    text-align: left;
    margin-left: 20px;
    margin-bottom: 16px;
  }
`;

const TABS = ["Teachers", "Schools/Districts", "Settings"];

const TeachersPage = ({ colors }) => {
  const [selectedTab, setSelectedTab] = usePersistentTabState(
    "admincentral.teachers.selectedTab",
    TABS[0]
  );

  useEffect(() => {
    if (!TABS.includes(selectedTab)) {
      setSelectedTab(TABS[0]);
    }
  }, [selectedTab, setSelectedTab]);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <DashboardContainer>
    <Title colors={colors}> Teachers </Title>
    <Container colors={colors}>
      <TeachersTabs colors={colors} selectedTab={selectedTab} handleTabClick={handleTabClick} />
      {selectedTab === "Teachers" && <TeachersContent colors={colors} />}
      {selectedTab === "Schools/Districts" && <SchoolDistrictContent colors={colors} />}
      {selectedTab === "Settings" && <TeacherSettingsContent colors={colors} />}
    </Container>
    </DashboardContainer>
  );
};

export default TeachersPage;
